import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ed2cddf&scoped=true&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ed2cddf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed2cddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed2cddf')) {
      api.createRecord('6ed2cddf', component.options)
    } else {
      api.reload('6ed2cddf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ed2cddf&scoped=true&lang=html", function () {
      api.rerender('6ed2cddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TinymceText/index.vue"
export default component.exports